import React,{useEffect, useState} from 'react'
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import {LinkContainer} from 'react-router-bootstrap'
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import about from '../../assets/img/slides/Abouts.png'
import {faCoffee} from '@fortawesome/free-solid-svg-icons/faCoffee'
import {faPhone} from '@fortawesome/free-solid-svg-icons/faPhone'
import {faMailBulk} from '@fortawesome/free-solid-svg-icons/faMailBulk'
import {faLocation} from '@fortawesome/free-solid-svg-icons/faLocation'
import { getAuth, signOut } from "firebase/auth";

import { db } from '../../Firebase';

import { SocialIcon } from 'react-social-icons'
import  'react-social-icons/facebook'
import 'react-social-icons/instagram'
import 'react-social-icons/youtube'

import Modal from '../Modal/Modal';

import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'
import { Col,Row, ListGroup,} from 'react-bootstrap'
;
import NavDropdown from 'react-bootstrap/NavDropdown';
import { MemoryRouter, Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import {Navbar, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';

 import channel from "../../assets/img/sarahs.png"
 import {  where, getDoc, updateDoc, doc, or } from "firebase/firestore";
import './Header.css'
import ReactDOM from "react-dom";
import Signin from '../SignModal/Signin';
import Register from '../Register/Register';
import { useDispatch, useSelector } from 'react-redux';
import { LOGOUT_SUCCESS, signOuts } from '../../Redux/actions/firebaseActions';
import Admin from '../dashboardLayout/dashboardLayout';
import { logout } from '../../Redux/Slices/userSlice';




const Header = () => {

  const auth = getAuth();

  const navigate = useNavigate()

  const dispatch = useDispatch()

  const signOutHandle = async () => {


    // await signOut(auth).then(() => {
    //   // Sign-out successful.
     

     

    // }).catch((error) => {
    //   // An error happened.
    // })

    // auth.signOut()
    dispatch(logout())
    navigate('/')

  }
  

  const [isAdmin, setIsAdmin] = useState(false)
  
  // const user = useSelector(state => state.user)
  const users = useSelector(state => state.user)

  const{user, isLoggedIn} = users

  const [userId, setUserId] = useState(null)



  const fetchUserData = async () => {
    if(user !== null){

        const userRef = doc(db, 'Users', user.uid);

        setUserId(user.uid)

        const userSnap = await getDoc(userRef);

        console.log('snap',userSnap)
        if (userSnap.exists()) {
          setIsAdmin(userSnap.data().isAdmin);  // Check if user is an admin

          console.log("isad",isAdmin)
        }

        console.log("test",userSnap)
  
    }
  
   
  };


useEffect(() => {

  fetchUserData()

},[userId, user])



  console.log("isAdmi User", user)

  // const {isLoggedIn, error} = user

  const [open, setOpen] = React.useState(false);
  return (
    <>
    
    
    <div  className='my-top'>

    <Row>
        <Col sm={3} className='mt-3 mx-auto  top-address'>
        
        <div className='top-icons'>

        <FontAwesomeIcon icon={faLocation}  className='text-primary mr-5'/>
       
        <ListGroup>
       
      <ListGroup.Item className="text-center">7701 Sudley Road , </ListGroup.Item>
      <ListGroup.Item className="text-center">Manassas, VA 20109</ListGroup.Item>
      
    </ListGroup>
          
    </div>
          </Col>


        <Col sm={3} className='mt-3 mx-auto top-phone'>
          <div className='top-icons  top-phone'>

          <FontAwesomeIcon icon={faPhone}  className='text-primary mr-5'/>
          <ListGroup>
      <ListGroup.Item className="text-center"> <a href="tel:703-936-3026">703-936-3026</a></ListGroup.Item>
      <ListGroup.Item className="text-center">Book An Appointment</ListGroup.Item>
    </ListGroup>
          </div>
          </Col>
        <Col sm={3} className='mt-3 mx-auto top-clock'>
        <div className='top-icons'>
        <FontAwesomeIcon icon={faClock}  className='text-primary mr-5'/>
          <ListGroup>
      <ListGroup.Item className="text-center"><h6 className='h6 hours-clock'>Mon-Sat:7:30am - 7:00pm</h6></ListGroup.Item>
      <ListGroup.Item className="text-center"><h6 className='h6 hours-clock'> Sundays 10:00am - 6:00pm</h6></ListGroup.Item>

    </ListGroup>
          
          </div>
          </Col>



          <Col sm={3} className='mt-3 mx-auto mr-auto'>
          
          <div className='top-social'>
<SocialIcon url="https://www.facebook.com/sarahadombraiding" />
    <SocialIcon url="https://www.instagram.com/sarahadombraiding/" />
    <SocialIcon url="#" />
    

</div>
          
          </Col>
      </Row>
    </div>
    
   

    <Navbar expand="lg" className="header-navbar navbar-dark" variant="dark">
      <Container fluid="lg" className="header-container">
      <Navbar.Brand as={Link} to="/" className="header-brand">
        <img src={channel} alt="Sarah Adom Braiding Salon" className="header-logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="navbarScroll" className="header-toggler" />
      <Navbar.Collapse id="navbarScroll" className="header-collapse">
        <Nav className="header-nav me-auto">
          {/* <Nav.Link to="/">Home</Nav.Link> */}
          <LinkContainer to="/">
          <Nav.Link>Home</Nav.Link>
          </LinkContainer>

          <LinkContainer to="/services">
          <Nav.Link>Services</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/appointment">
          <Nav.Link>Appointment</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/gallery">
          <Nav.Link>Gallery</Nav.Link>
          </LinkContainer>
          <NavDropdown title="About" id="aboutDropdown" className="header-dropdown">
            <LinkContainer to="/about">
              <NavDropdown.Item>About Us</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/contact">
              <NavDropdown.Item>Contact Us</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/faq">
              <NavDropdown.Item>FAQ</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/reviews">
              <NavDropdown.Item>Privacy & Terms</NavDropdown.Item>
            </LinkContainer>
          </NavDropdown>


          {isLoggedIn && isAdmin && (
          <NavDropdown title="Admin" id="adminDropdown" className="header-dropdown">
            <LinkContainer to="/upload">
              <NavDropdown.Item>Add Gallery Images</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/addstylist">
              <NavDropdown.Item>Add Stylist</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/lists">
              <NavDropdown.Item>View Appointments</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/appointments">
              <NavDropdown.Item>All Appointments</NavDropdown.Item>
            </LinkContainer>
          </NavDropdown>
          )}
        
          <LinkContainer to="/location">
          <Nav.Link  className="">
           Location
          </Nav.Link>
          </LinkContainer>



     
         
     

        </Nav>
        {/* <Form className="d-flex">
          <Form.Control
            type="search"
            placeholder="Search"
            className="me-2"
            aria-label="Search"
          />
          <Button variant="outline-primary">Search</Button>
        </Form> */}

      

       
       <Nav className="header-nav-right align-items-center">
          <a
            href="https://takeachair.com/salon-info?salonId=IHi7PDJMLomwaOqeotpm"
            target="_blank"
            rel="noopener noreferrer"
            className="header-book-btn"
          >
            Book an appointment
          </a>
          {!isLoggedIn && (
            <>
              <div className="header-modal-wrap">
                <Modal />
              </div>
              <Nav.Link as="div" className="header-signin">
                <Signin />
              </Nav.Link>
            </>
          )}
          {isLoggedIn && isAdmin && (
            <LinkContainer to="/admin">
              <Nav.Link>Admin</Nav.Link>
            </LinkContainer>
          )}
          {isLoggedIn && (
            <Nav.Link onClick={signOutHandle} className="header-logout" as="button" type="button">
              Log out
            </Nav.Link>
          )}
        </Nav>
      </Navbar.Collapse>
    </Container>


  </Navbar>


  
  </>
  )
}

export default Header